import type { operations } from '@/types/schemas/api.JS-10706';
import { PATCH, setParams } from '../../_http';
type controller = operations['BrokerUpdateApplicationDraftController_patch'];

export type BrokerUpdateApplicationDraftBody = controller['requestBody']['content']['application/json'];
export type BrokerUpdateApplicationDraftQuery = controller['parameters']['query'];
export type BrokerUpdateApplicationDraftResponse = controller['responses']['200']['content']['application/json'];

export const brokerUpdateApplicationDraft = PATCH(
  '/brokers/applications-draft/update-application-draft',
  setParams<BrokerUpdateApplicationDraftQuery>,
)<BrokerUpdateApplicationDraftBody, BrokerUpdateApplicationDraftResponse>;
